import { useState, useMemo } from 'react';
import { useGetLogAuditoriaSiniestroQuery } from '../../../services/roamApi';
import { LogAuditoriaItem, TipoEventoAuditoria } from '../types/siniestros.types';

interface FiltrosLogAuditoria {
    tipoEvento?: TipoEventoAuditoria | '';
    actor?: string;
}

interface UseLogAuditoriaResult {
    entradas: LogAuditoriaItem[];
    entradasFiltradas: LogAuditoriaItem[];
    filtros: FiltrosLogAuditoria;
    setFiltro: (key: keyof FiltrosLogAuditoria, value: TipoEventoAuditoria | string | '') => void;
    expandedIds: Set<number>;
    toggleExpanded: (id: number) => void;
    isLoading: boolean;
    error: boolean;
}

export function useLogAuditoria(idSiniestroRoam: number | undefined): UseLogAuditoriaResult {
    const [filtros, setFiltros] = useState<FiltrosLogAuditoria>({});
    const [expandedIds, setExpandedIds] = useState<Set<number>>(new Set());

    const {
        data: entradas = [],
        isFetching,
        isError
    } = useGetLogAuditoriaSiniestroQuery(
        { idSiniestroRoam: idSiniestroRoam as number },
        { skip: !idSiniestroRoam }
    );

    const entradasFiltradas = useMemo(() => {
        return entradas.filter((entrada) => {
            if (filtros.tipoEvento && entrada.tipoEvento !== filtros.tipoEvento) return false;
            if (filtros.actor && entrada.actor !== filtros.actor) return false;
            return true;
        });
    }, [entradas, filtros]);

    const setFiltro = (
        key: keyof FiltrosLogAuditoria,
        value: TipoEventoAuditoria | string | ''
    ) => {
        setFiltros((prev) => ({ ...prev, [key]: value }));
    };

    const toggleExpanded = (id: number) => {
        setExpandedIds((prev) => {
            const next = new Set(prev);
            if (next.has(id)) {
                next.delete(id);
            } else {
                next.add(id);
            }
            return next;
        });
    };

    return {
        entradas,
        entradasFiltradas,
        filtros,
        setFiltro,
        expandedIds,
        toggleExpanded,
        isLoading: isFetching,
        error: isError
    };
}
